import Vue from 'vue'
import VueProgressBar from 'vue-progressbar'

export default () => {
  Vue.use(VueProgressBar, {
    transition: {
      termination: 600
    },
    autoFinish: false
  })
}
